import { AwsS3AuditRegistration } from "@p0security/integrations-aws-s3-audit-shared";
import type { AwsS3AuditComponents } from "@p0security/integrations-aws-s3-audit-shared";
import { Install } from "@p0security/integrations-installer";
import type { InstallProps } from "@p0security/integrations-installer";

import { awsS3AuditInstaller } from "./install";

export const AwsS3Audit = (
  props: Pick<
    InstallProps<typeof AwsS3AuditComponents>,
    "cardOverride" | "onInstall" | "siblings"
  >
) => (
  <Install<typeof AwsS3AuditComponents>
    installer={awsS3AuditInstaller}
    integration="aws-s3-audit"
    registration={AwsS3AuditRegistration}
    {...props}
  />
);
